import React, { Component, Fragment, useState, useEffect } from "react";

import { NavLink, Link, useLocation } from "react-router-dom";

import $ from "jquery";

const SideMenuLi = ({ id, name, icon, path, path_exact, childs }) => {
    const location = useLocation();
    const [pathname, setPathname] = useState(location.pathname);
    useEffect(() => {
        if (location.pathname !== pathname) {
            setPathname(location.pathname);
        }
        return () => {};
    }, [pathname, location.pathname]);

    if (childs) {
        return (
            <li className="nav-item" id={id}>
                <a className="nav-link" href="#" data-toggle="collapse" data-target={"#" + id + "_child"} aria-controls={id + "_child"} aria-expanded="true">
                    <i className={"mr-0 " + icon} />
                    <span className="ml-2">{name}</span>
                </a>
                <div id={id + "_child"} className="submenu collapse show pl-3">
                    <ul className="nav flex-column">
                        {childs.map((child, index) => {
                            if (child.child && child.child.length > 0) {
                                return (
                                    <SideMenuLi
                                        key={"menu_Li_Li_" + index}
                                        id={child.id}
                                        auth={child.auth}
                                        name={child.name}
                                        url={child.path}
                                        path_exact={path_exact}
                                        icon={child.icon}
                                        childs={child.child}
                                    />
                                );
                            } else {
                                var isActive = child.path ? child.path == pathname + location.search : false;
                                var className = isActive ? "nav-link active" : "nav-link";
                                if (child.path) {
                                    var pathExternal = child.path.indexOf("http") == 0;
                                    return (
                                        <li className="nav-item" id={child.id} key={"sideMenu_" + index + "_" + child.id}>
                                            {pathExternal && (
                                                <a className={className} href={child.path ? child.path : ""} target={"_blank"}>
                                                    {child.icon && <i className={"mr-0 " + child.icon} />}
                                                    <span className="ml-2">{child.name}</span>
                                                </a>
                                            )}
                                            {!pathExternal && (
                                                <>
                                                    {child.is_nav == 1 && (
                                                        <NavLink activeClassName={""} className={className} exact={child.path_exact != 0} to={child.path ? child.path : ""}>
                                                            {child.icon && <i className={"mr-0 " + child.icon} />}
                                                            <span className="ml-2">{child.name}</span>
                                                        </NavLink>
                                                    )}
                                                    {!child.is_nav && (
                                                        <a className={className} href={child.path ? child.path : ""}>
                                                            {child.icon && <i className={"mr-0 " + child.icon} />}
                                                            <span className="ml-2">{child.name}</span>
                                                        </a>
                                                    )}
                                                </>
                                            )}
                                        </li>
                                    );
                                } else {
                                    return (
                                        <li className="nav-item" style={{ padding: "6px 12px" }} id={child.id} key={"sideMenu_" + index + "_" + child.id}>
                                            <span className="ml-2">{child.name}</span>
                                        </li>
                                    );
                                }
                            }
                        })}
                    </ul>
                </div>
            </li>
        );
    } else {
        var isActive = menu.path ? menu.path.indexOf(pathname + location.search) > -1 : false;
        var className = isActive ? "nav-link active" : "nav-link";
        return (
            <>
                {child.is_nav && (
                    <NavLink activeClassName={""} className={className} exact={child.path_exact} to={child.path ? child.path : ""}>
                        {child.icon && <i className={"mr-0 " + child.icon} />}
                        <span className="ml-2">{child.name}</span>
                    </NavLink>
                )}
                {!child.is_nav && (
                    <a className={className} href={child.path ? child.path : ""}>
                        {child.icon && <i className={"mr-0 " + child.icon} />}
                        <span className="ml-2">{child.name}</span>
                    </a>
                )}
            </>
        );
    }
};

const SideMenus = ({ menuList }) => {
    const location = useLocation();
    const [pathname, setPathname] = useState(location.pathname);
    useEffect(() => {
        if (location.pathname !== pathname) {
            setPathname(location.pathname);
        }
        return () => {};
    }, [pathname, location.pathname]);

    if (menuList) {
        return menuList.map((menu, i) => {
            if (menu.display_order > 0) menu.isShow = true;
            if (menu.isShow) {
                var isActive = menu.path ? menu.path.indexOf(pathname + location.search) > -1 : false;
                var className = isActive ? "nav-link active" : "nav-link";
                if (menu.child && menu.child.length > 0) {
                    return <SideMenuLi key={"menu_Li_" + i} id={menu.id} auth={menu.auth} name={menu.name} url={menu.path} icon={menu.icon} childs={menu.child} />;
                } else {
                    var pathExternal = menu.path.indexOf("http") == 0;
                    return (
                        <>
                            {pathExternal && (
                                <a className={className} href={menu.path} target={"_blank"} key={"menu_Li_" + i}>
                                    {menu.icon && <i className={"mr-0 " + menu.icon} />}
                                    <span className="ml-2">{menu.name}</span>
                                </a>
                            )}
                            {!pathExternal && (
                                <>
                                    {menu.is_nav && (
                                        <NavLink activeClassName={""} className={className} exact={menu.path_exact != 0} to={menu.path} key={"menu_Li_" + i}>
                                            {menu.icon && <i className={"mr-0 " + menu.icon} />}
                                            <span className="ml-2">{menu.name}</span>
                                        </NavLink>
                                    )}
                                    {!menu.is_nav && (
                                        <a className={className} href={menu.path} key={"menu_Li_" + i}>
                                            {menu.icon && <i className={"mr-0 " + menu.icon} />}
                                            <span className="ml-2">{menu.name}</span>
                                        </a>
                                    )}
                                </>
                            )}
                        </>
                    );
                }
            } else {
                return null;
            }
        });
    } else {
        return null;
    }
};

class Side extends Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate(prevProps) {
        $(function () {
            var navMain = $(".navbar-collapse"); // avoid dependency on #id
            // "a:not([data-toggle])" - to avoid issues caused
            // when you have dropdown inside navbar
            navMain.on("click", "a:not([data-toggle])", null, function (e) {
                navMain.removeClass("show");
            });
        });
    }

    render() {
        const menuList = this.props.menuList;
        return (
            <div className="nav-left-sidebar sidebar">
                <div className="menu-list">
                    <nav className="navbar navbar-expand-md navbar-light">
                        <Link className="d-xl-none d-lg-none d-md-none" to="/">
                            &nbsp;
                        </Link>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav flex-column">
                                {menuList &&
                                    menuList.map((menu, index) => {
                                        return (
                                            <div key={`menu-li-${index}-menus`}>
                                                <li className="nav-divider" style={{paddingBottom: "0px"}}>{menu.c_name}</li>
                                                <SideMenus menuList={menu.menu} key={`menu-li-${index}-menus-sides`} />
                                            </div>
                                        );
                                    })}
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        );
    }
}

export default Side;
